import { AxiosResponse } from 'axios';
import { useHttpClient } from '../components/infra/httpClient.component';

interface LoginRequest {
    login: string,
}

interface SessionRequest {
    code: string,
}

interface PromoCodeRequest {
    code: string,
}

export interface SessionInfo {
    login: string,
}

export const useLoginService = () => {
    const httpClient = useHttpClient(); 
    const doLogin = (data: LoginRequest): Promise<AxiosResponse<any, any>> => {
        return httpClient.post(`login`, data);
    };

    const healthCheck = (): Promise<AxiosResponse<any, any>> => {
        return httpClient.get(`healthCheck/login`);
    };

    // Trades the one-time code received from the login hub for the session cookie
    const createSession = (data: SessionRequest): Promise<AxiosResponse<any, any>> => {
        return httpClient.post(`login/session`, data);
    };

    // Logs in with a one-time promo code; the API answers with the session cookie
    const promoLogin = (data: PromoCodeRequest): Promise<AxiosResponse<any, any>> => {
        return httpClient.post(`login/promo`, data);
    };

    const me = (): Promise<AxiosResponse<SessionInfo, any>> => {
        return httpClient.get(`login/me`);
    };

    const logout = (): Promise<AxiosResponse<any, any>> => {
        return httpClient.post(`login/logout`);
    };

    return { doLogin, healthCheck, createSession, promoLogin, me, logout };
};
